export const selectProfile = state => state.profile.data;
export const selectProfileLoading = state => state.profile.loading.profile;
export const selectProfileError = state => state.profile.error.profile;
export const selectUserStats = state => state.profile.stats;
export const selectWatchedMovies = state => state.profile.watchedMovies;
export const selectUserReviews = state => state.profile.reviews;
export const selectUserRatings = state => state.profile.ratings;
export const selectFavoriteGenres = state => state.profile.favoriteGenres;
export const selectProfileSettings = state => state.profile.settings;
